import { useListFilterContext } from '@yimoka/antd';
import { Radio, Select, type RadioGroupProps, type SelectProps } from 'antd';

import { useTranslation } from '@/locales/i18n';

export interface BooleanChoiceProps extends Omit<RadioGroupProps, 'onChange' | 'options' | 'value'> {
  falseLabel?: string;
  onChange?: (value?: boolean) => void;
  trueLabel?: string;
  value?: boolean | null;
}

/** 为表单和 Schema 提供语义明确的布尔选择，避免只靠开关位置表达业务值。 */
export function BooleanChoice({
  buttonStyle,
  falseLabel,
  onChange,
  optionType,
  trueLabel,
  value,
  ...props
}: BooleanChoiceProps) {
  const { t } = useTranslation();
  const isListFilter = useListFilterContext();
  const options = [
    { label: trueLabel ?? t('Common:yes'), value: 'true' },
    { label: falseLabel ?? t('Common:no'), value: 'false' },
  ];
  const normalizedValue = value === undefined || value === null ? undefined : String(value);

  if (isListFilter) {
    // 筛选值需要可恢复为 undefined；下拉的清除动作明确表达“不按此字段筛选”。
    return (
      <Select<string>
        {...props as SelectProps<string>}
        allowClear
        options={options}
        value={normalizedValue}
        onChange={selectedValue => onChange?.(
          selectedValue === undefined ? undefined : selectedValue === 'true',
        )}
      />
    );
  }

  return (
    <Radio.Group
      {...props}
      buttonStyle={buttonStyle ?? 'solid'}
      optionType={optionType ?? 'button'}
      options={options}
      value={normalizedValue}
      onChange={event => onChange?.(event.target.value === 'true')}
    />
  );
}

export default BooleanChoice;
